let endpoint = process.env.REACT_APP_API_URL;
if (endpoint && !endpoint.startsWith("http")) {
  endpoint = `https://${endpoint}/api`;
}
if (endpoint) {
  endpoint = endpoint.replace(
    "[subdomain]",
    JSON.parse(localStorage.getItem("selectedTenant") || "{}")?.subdomain
  );
}
// global.console.log('endpoint', endpoint)
export const BASE_URL = endpoint || "https://verhoeven.api-staging.aedo.nl/api";
export const LS_TOKEN_KEY = "access_token";
